import { useSwipeable, } from 'react-swipeable';
const Swipeable = ({ children, ...otherProps }) => {
    const handlers = useSwipeable(otherProps);
    return children(handlers);
};
export default Swipeable;
